import { NextSeo } from 'next-seo';
import React from 'react';
import PageHeader from '../../components/PageHeader';
import TheJobsPage from '../../components/TheJobsPage';
import config from '../../config';

function Page() {
  const title = `Shitty Jobs - ${config.siteName}`;
  const description = `An AI-powered Shitty Job Board.`;

  return (
    <>
      <NextSeo title={title} description={description} />
      <div className='pb-12 md:pb-48 bg-bg'>
        <TheJobsPage />
      </div>
    </>
  );
}

export default Page;
